import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CatalogoEnfermedadesCatastroficasDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoEnfermedadesCatastroficasService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getCatalogoEnfermedadesCatastroficasService(): Observable<BodyListResponse<CatalogoEnfermedadesCatastroficasDTO>> {
    return this.http.get<BodyListResponse<CatalogoEnfermedadesCatastroficasDTO>>(API_URL + '/api/v1/catalogoEnfermedadesCatastroficas/todos');
  }

  guardarCatalogoEnfermedadesCatastroficasService(catalogoEnfermedadesCatastroficasDTO: CatalogoEnfermedadesCatastroficasDTO): Observable<CatalogoEnfermedadesCatastroficasDTO> {
    return this.http.post<CatalogoEnfermedadesCatastroficasDTO>(API_URL + '/api/v1/catalogoEnfermedadesCatastroficas', catalogoEnfermedadesCatastroficasDTO);
  }
    
  getCatalogoEnfermedadesCatastroficasPorCodigoCatalogoEnfermedadesCatastroficasService(codigoCatalogoEnfermedadesCatastroficas: string): Observable<BodyResponse<CatalogoEnfermedadesCatastroficasDTO>> {
    return this.http.get<BodyResponse<CatalogoEnfermedadesCatastroficasDTO>>(API_URL + '/api/v1/catalogoEnfermedadesCatastroficas/' + codigoCatalogoEnfermedadesCatastroficas);
  }
}
